import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  avatarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  fieldWrapper: {
    marginBottom: theme.spacing(4),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -4,
    marginLeft: -12,
  },
  submitButton: {
    margin: theme.spacing(4, 0, 2),
  },
}));

export default useStyles;
